import Keycloak from "keycloak-js";
import { METAFORM_MANAGER_ROLE, METATAVU_ADMIN_ROLE, SYSTEM_ADMIN_ROLE } from "consts";

/**
 * Utility class for auth
 */
namespace AuthUtils {

  /**
   * Checks for admin permission
   *
   * @param keycloak keycloak
  */
  export const isSystemAdmin = (keycloak?: Keycloak): boolean => {
    if (!keycloak?.token) {
      return false;
    }

    return keycloak?.hasRealmRole(SYSTEM_ADMIN_ROLE);
  };

  /**
   * Checks for Metatavu administrator permission.
   *
   * @param keycloak keycloak
   */
  export const isMetatavuAdmin = (keycloak?: Keycloak): boolean => {
    if (!keycloak?.token) {
      return false;
    }

    return keycloak.hasRealmRole(METATAVU_ADMIN_ROLE);
  };

  /**
   * Checks whether the user can administer forms globally.
   *
   * @param keycloak keycloak
   */
  export const isGlobalFormAdmin = (keycloak?: Keycloak): boolean => (
    isSystemAdmin(keycloak) || isMetatavuAdmin(keycloak)
  );

  /**
   * Checks for metaform manager permission
   * 
   * @param keycloak keycloak
   */
  export const isMetaformManager = (keycloak?: Keycloak): boolean => {
    if (!keycloak?.token) {
      return false;
    }

    if (isGlobalFormAdmin(keycloak)) {
      return true;
    }

    return keycloak?.hasRealmRole(METAFORM_MANAGER_ROLE);
  };

}

export default AuthUtils;